import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleMenu } from "../utils/appSlice";
import { YOUTUBE_SEARCH_API } from "../utils/contants";
import { cacheResults } from "../utils/searchSlice";
// import { Link } from "react-router-dom";
import {  useNavigate } from "react-router-dom";

const Head = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const suggestionsRef = useRef(null);
  const navigate = useNavigate();

  const searchCache = useSelector((store) => store.search);
  const dispatch = useDispatch();

  const handleKeyDown = (e)=>{
    if(e.key === "Enter" && searchQuery!=null && searchQuery!=='')
      handleSelection(searchQuery);
  }

  const handleSelection = (s) => {
    console.log(s);
    navigate(`/results?search_query=${s}`);
    setShowSuggestions(false);
  };

  /**
   *  searchCache = {
   *     "iphone": ["iphone 11", "iphone 14"]
   *  }
   *  searchQuery = iphone
   */

  // //adding scroll hiding nature for search suggestion
  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (suggestionsRef.current) {
  //       const rect = suggestionsRef.current.getBoundingClientRect();
  //       if (rect.bottom < 0 || rect.top > window.innerHeight) {
  //         setShowSuggestions(false);
  //       }
  //     }
  //   };

  //   window.addEventListener('scroll', handleScroll);

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchCache[searchQuery]) {
        setSuggestions(searchCache[searchQuery]);
      } else {
        getSearchSugsestions();
      }
    }, 200);

    return () => {
      clearTimeout(timer);
    };
  }, [searchQuery]);

  const getSearchSugsestions = async () => {
    const data = await fetch(YOUTUBE_SEARCH_API + searchQuery);
    const json = await data.json();
    //console.log(json[1]);
    setSuggestions(json[1]);

    // update cache
    dispatch(
      cacheResults({
        [searchQuery]: json[1],
      })
    );
  };

  const toggleMenuHandler = () => {
    dispatch(toggleMenu());
  };
// className="md:w-8 w-7 md:h-8 h-6 md:mx-4 mr-2 cursor-pointer
  return (
    <div className="flex flex-row justify-between p-[1.5%] h-10 md:h-14 shadow-lg w-screen bg-gradient-to-b from-gray-800 fixed z-10">
      <div className="flex md:w-[30%] w-[20%] mr-6">
        <img
          onClick={() => toggleMenuHandler()}
          className="md:w-8 md:h-8 md:mx-4 md:cursor-pointer md:block hidden"
          alt="menu"
          src="/burger-bar.png"
        />
        <a href="/">
          <img
            className="md:h-8 h-6 md:mx-1 md:p-1 p-0.5"
            alt="youtube-logo"
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/YouTube_Logo_2017.svg/2560px-YouTube_Logo_2017.svg.png"
          />
        </a>
      </div>
      <div className="md:w-[60%] w-[70%] ">
          <input
            className=" border md:w-[80%] w-[80%] p-2 md:h-8 h-6 border-gray-400 rounded-full"
            type="text"
            placeholder="🔍 Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onFocus={() => setShowSuggestions(true)}
            onBlur={() => setShowSuggestions(false)}
            onKeyDown={(e) => handleKeyDown(e)}
          />
          {/* <button className="border border-gray-400 md:h-8 h-6.5 md:px-[1%] md:py-[-1%] rounded-r-full bg-gray-100">
            🔍
          </button> */}
        {/* </div> */}
        {showSuggestions && (
          <div ref={suggestionsRef} className="fixed bg-white md:px-[1%] md:w-[50%] w-[55%] shadow-lg rounded-lg border border-gray-100 ">
            <ul>
              {suggestions && suggestions.map((s) => (
                <li 
                  key={s} 
                  className="flex flex-row md:py-[1%] md:px-[1.5%] shadow-sm hover:bg-gray-100"  
                  onMouseDown={() => handleSelection(s)}
                  >
                {/* <Link to={`/results?search_query=${s}`}> */}
                  <img className="w-[8%] h-[8%] mr-[4%]" alt="search" src="/search.png"/> <p> {s}</p>
                {/* </Link> */}
                  </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <div className="md:w-[10%] w-[10%]">
        <img
          className="md:h-10 h-6 md:w-10 w-6 md:pb-1.5 pb-0.25 md:ml-8 ml-2"
          alt="user"
          src="https://www.iconpacks.net/icons/2/free-user-icon-3296-thumb.png"
        />
      </div>
    </div>
  );
};

export default Head;
